import { useQuery } from '@tanstack/react-query'
import { PaytrieAPI } from '@paytrie/client'

import { usePageStateStore } from '@/reducers'

const STALE_TIME_MS = 5 * 60 * 1000

export class CurrentUserError extends Error {
  constructor(readonly status: number) {
    super(`Failed to load current user (status ${status})`)
  }
}

export const useCurrentUser = (enabled: boolean) => {
  const authToken = usePageStateStore.use.authToken()
  return useQuery({
    queryKey: ['v2', 'users', 'me', authToken],
    queryFn: async () => {
      const res = await PaytrieAPI.getCurrentUser()
      if (res.status !== 200) {
        throw new CurrentUserError(res.status)
      }
      return res.data.data
    },
    enabled,
    retry: (failureCount, error) =>
      !(error instanceof CurrentUserError && error.status === 401) &&
      failureCount < 2,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 5000),
    staleTime: STALE_TIME_MS,
  })
}
